export default __webpack_public_path__ + "static/media/Fatiha.7d5c0df6.mp3";